export type SignalListener<T> = (value: T) => void;
export type SignalUnsubscribe = () => void;

export class ValueSignal<T> {
  private listeners = new Set<SignalListener<T>>();
  private current: T;

  constructor(initial_value: T) {
    this.current = initial_value;
  }

  get value(): T {
    return this.current;
  }

  set(value: T) {
    this.current = value;
    this.listeners.forEach((listener) => listener(value));
  }

  subscribe(listener: SignalListener<T>): SignalUnsubscribe {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}
